export default __webpack_public_path__ + "static/media/hht2_ep1_speaking_02.4aa7a43b.png";